/**
 * Fix LOW-03 (auditoría de seguridad, 2026-09-07): silencia console.log/
 * console.debug/console.info en builds de producción. console.warn y
 * console.error quedan intactos a propósito -- son de mucho menor volumen
 * y sí tienen valor real para diagnosticar un error ya en producción.
 *
 * No toca nada fuera de producción (dev/test) para no romper el flujo de
 * desarrollo normal.
 */
export default function silenceConsoleInProduction(env = process.env.NODE_ENV) {
  if (env !== 'production') {
    return;
  }
  /* eslint-disable no-console */
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  /* eslint-enable no-console */
}
